<template>

<div class="row">

    <div class="form-group col-6">
        <label for='pwd'>Стара парола</label>
        <input class='form-control' type='password' id='pwd' v-model='model.pwd'>
    </div>

    <div class="form-group col-6">
        <label for='new_pwd'>Нова парола</label>
        <input class='form-control' type='password' id='new_pwd' v-model='model.new_pwd'>
    </div>
    
    <div class="form-group col-6">
        <label for='pwd-repeat'>Повтори новата парола</label>
        <input class='form-control' type='password' id='pwd-repeat' v-model='pwdRepeat'>
    </div>

    <div class="form-group col-12 text-center">
        <form-validator ref='validator' :fields='validatorFields'></form-validator>
        <hr/>

        <button @click='save' class='btn btn-success'>
            Запази
        </button>
    </div>

</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
           
        },

        data() {
            return {
                isReady : false,

                model : {
                    pwd : '',
                    new_pwd : ''
                },

                pwdRepeat : '',

                //Validate User info
                validatorFields : [
                    { 
                        selector  : "#pwd",
                        minLength : 8,
                        customErr : 'Моля въведете текущата си парола'
                    },
                    { 
                        selector  : "#new_pwd",
                        minLength : 8,
                        customErr : 'Моля въведете нова парола ( поне 8 символа )'
                    },
                    { 
                        selector  : "#pwd-repeat",
                        minLength : 8,
                        sameAs    : "#new_pwd",
                        customErr : 'Повторението на паролата е задължително и трябва да съвпада.'
                    }
                ]
            }
        },

        methods : {
            save() {

                var me = this;

                this.$refs.validator.validate({
                    resolve() {

                        me.isLoading = true;

                        me.ajax.call('usr:chp', me.model , (r) => {
                            me.isLoading = false;

                            if( r.status == 'success' ) {

                                me.notify('save-success');

                                me.model.pwd = '';
                                me.model.new_pwd = '';
                                me.pwdRepeat = '';

                            } else {

                                $.notify( r.message, r.status );
                            }

                        })

                    }
                })

            },
        }

    }
</script>
